document.addEventListener('click', function (e) {

  const button = e.target.closest('.add-to-bag-btn');
  if (!button) return;

  e.preventDefault();

  console.log('🟢 Add to Bag clicked');

  let variantId = null;

  /* -------------------------
     FIND SELECT IN SAME CARD
  ------------------------- */

  const productCard = button.closest(
    '.product-card-container, .taste-the-purity-taste-the-purity-product-card-container, .card-product-action-container, .custom-add-to-cart-wrapper'
  );

  if (productCard) {
    const select = productCard.querySelector('.variant-selector');

    if (select) {
      variantId = select.value;
      console.log('Variant from dropdown:', variantId);
    }
  }

  /* -------------------------
     SIMPLE PRODUCT
  ------------------------- */

  if (!variantId && button.dataset.id) {
    variantId = button.dataset.id;
    console.log('Simple product:', variantId);
  }

  /* -------------------------
     FALLBACK (OLD METHOD)
  ------------------------- */

  if (!variantId && button.dataset.productIndex) {

    const select = document.querySelector(
      `#variant-select-${button.dataset.productIndex}`
    );

    if (select) {
      variantId = select.value;
      console.log('Fallback variant:', variantId);
    }
  }

  if (!variantId) {
    console.error('❌ Variant ID not found');
    return;
  }

  button.disabled = true;

  console.log('🟡 Sending request to /cart/add.js');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => {
    console.log('🟢 Product added');
    return response.json();
  })
  .then(data => {

    console.log('Cart add response:', data);

    return fetch('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble');

  })
  .then(res => res.json())
  .then(sections => {

    console.log('🟢 Sections fetched');

    const miniCart = document.getElementById('mini-cart');

    if (!miniCart) {
      console.error('❌ Mini cart not found');
      location.reload();
      return;
    }

    miniCart.renderContents({
      id: variantId,
      sections: sections
    });

    console.log('🟢 Cart drawer updated');

  })
  .catch(error => {
    console.error('❌ Error:', error);
  })
  .finally(() => {
    button.disabled = false;
  });

});

// You May Also Like - variant price change
document.addEventListener('change', function (e) {

  const select = e.target.closest(
    'product-recommendations .variant-selector'
  );

  if (!select) return;

  console.log('🔵 Recommendation variant changed:', select.value);

  const wrapper = select.closest('.custom-add-to-cart-wrapper');
  const parent = wrapper?.parentElement;

  const priceWrapper = parent?.querySelector('.price-wrapper');
  const productJson = parent?.querySelector('.product-json');

  if (!priceWrapper || !productJson) {
    console.error('❌ Recommendation price elements not found');
    return;
  }

  const product = JSON.parse(productJson.textContent);

  const variant = product.variants.find(
    v => v.id == select.value
  );

  if (!variant) {
    console.error('❌ Variant not found:', select.value);
    return;
  }

  const dd = priceWrapper.querySelector('dd');

  if (!dd) {
    console.error('❌ Price DD not found');
    return;
  }

  let html = '';

  /*
   * Variant has a compare-at price
   */
  if (
    variant.compare_at_price &&
    variant.compare_at_price > variant.price
  ) {

    html = `
      <span class="price-item price-item--compare">
        <price-money>
          <bdi>${formatMoney(variant.compare_at_price)}</bdi>
        </price-money>
      </span>

      <span class="price-item price-item--sale">
        <price-money>
          <bdi>${formatMoney(variant.price)}</bdi>
        </price-money>
      </span>
    `;

  } else {

    /*
     * No compare-at price
     */
    html = `
      <span class="price-item price-item--regular">
        <price-money>
          <bdi>${formatMoney(variant.price)}</bdi>
        </price-money>
      </span>
    `;
  }

  dd.innerHTML = html;

  console.log(
    '💰 Recommendation price updated:',
    variant.title,
    'Price:',
    variant.price,
    'Compare:',
    variant.compare_at_price
  );

});